import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, Route } from "@angular/router";

import { Observable, of } from "rxjs";
import { RoutesService } from "./routes.service";
import { AuthService } from "./auth.service";

@Injectable()
export class FeatureGuardService {

    constructor(private router: Router, private routesService: RoutesService) {
    }

    canActivate(activatedRoute: ActivatedRouteSnapshot): Observable<boolean> {
        const routes: Route[] = this.routesService.getNavigationRoutes(this.router, AuthService.businessFunction);
        if (activatedRoute.routeConfig && routes.filter((e: Route) => e.path === activatedRoute.routeConfig!.path).length > 0) {
            return of(true);
        }

        this.router.navigate(["/unauthorized"]);
        return of(false);
    }
}
